import { render, staticRenderFns } from "./HowToPlay.vue?vue&type=template&id=01386cc5&scoped=true&"
import script from "./HowToPlay.vue?vue&type=script&lang=js&"
export * from "./HowToPlay.vue?vue&type=script&lang=js&"
import style0 from "./HowToPlay.vue?vue&type=style&index=0&id=01386cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01386cc5",
  null
  
)

export default component.exports